import { BaseItem } from './common';

export interface BasePatientAdvisoryDocument {
  type: string;
  subject: string | null;
  facility: string | null;
  date: Date;
  gsPath: string;
  patientAdvisoryId: string;
}
export interface PatientAdvisoryDocument
  extends BaseItem,
    BasePatientAdvisoryDocument {}

export interface BaseAdvisory {
  id: string;
  recommendation: string | null;
  recommendationRaw: string;
  patientAdvisoryDocuments: PatientAdvisoryDocument[];
}

export interface PatientAdvisory extends BaseItem, BaseAdvisory {}

export enum Recommendation {
  AlcoholDependence = 'ALCOHOL_DEPENDENCE',
  AmputationStatus = 'AMPUTATION_STATUS',
  AnnualWellnessVisit = 'ANNUAL_WELLNESS_VISIT',
  BenzodiazepineDependence = 'BENZODIAZEPINE_DEPENDENCE',
  CareOfOlderAdultsMedicationReconciliation = 'CARE_OF_OLDER_ADULTS_MEDICATION_RECONCILIATION',
  CareOfOlderAdultsPainScale = 'CARE_OF_OLDER_ADULTS_PAIN_SCALE',
  CervicalCancerScreening = 'CERVICAL_CANCER_SCREENING',
  ComplicatedDiabetesType1Neuropathy = 'COMPLICATED_DIABETES_TYPE_1_NEUROPATHY',
  ComplicatedDiabetesType1Retinopathy = 'COMPLICATED_DIABETES_TYPE_1_RETINOPATHY',
  ComplicatedDiabetesType2Neuropathy = 'COMPLICATED_DIABETES_TYPE_2_NEUROPATHY',
  ComplicatedDiabetesType2Retinopathy = 'COMPLICATED_DIABETES_TYPE_2_RETINOPATHY',
  CongestiveHeartFailure = 'CONGESTIVE_HEART_FAILURE',
  COPD = 'COPD',
  CT = 'CT',
  DeliveryReport = 'DELIVERY_REPORT',
  DepressionScreening = 'DEPRESSION_SCREENING',
  DiabetesEyeExam = 'DIABETES_EYE_EXAM',
  DiabetesHbA1cMonitoring = 'DIABETES_HBA1C_MONITORING',
  DiabetesNephropathyMonitoring = 'DIABETES_NEPHROPATHY_MONITORING',
  DiagnosticRadiology = 'DIAGNOSTIC_RADIOLOGY',
  FollowUpAfterEmergencyHighRiskConditions = 'FOLLOW_UP_AFTER_EMERGENCY_HIGH_RISK_CONDITIONS',
  HelixDnr = 'HELIX_DNA',
  Hypertension = 'HYPERTENSION',
  ImagingReport = 'IMAGING_REPORT',
  MajorDepressiveDisorderSingleEpisodeMild = 'MAJOR_DEPRESSIVE_DISORDER_SINGLE_EPISODE_MILD',
  MedicationReconciliationPostDischarge = 'MEDICATION_RECONCILIATION_POST_DISCHARGE',
  MRA = 'MRA',
  MRI = 'MRI',
  OmadaDiabetes = 'OMADA_DIABETES',
  OmadaPreDiabetes = 'OMADA_PRE_DIABETES',
  OpioidDependence = 'OPIOID_DEPENDENCE',
  Ostomy = 'OSTOMY',
  PrenatalAndPostPartumCare = 'PRENATAL_AND_POSTPARTUM_CARE',
  PreventiveCareBreastCancerScreeningForWomenFrom50To75 = 'PREVENTIVE_CARE_BREAST_CANCER_SCREENING_RECOMMENDED_EVERY_1_2_YEARS_FOR_WOMEN_BETWEEN_AGES 50_75_YEARS',
  PreventiveCareColonCancerScreen = 'PREVENTIVE_CARE_COLON_CANCER_SCREEN',
  PreventiveCareCovid19Vaccine = 'PREVENTIVE_CARE_COVID19_VACCINE',
  PreventiveCareDEXAScreeningForPatients65AndOver = 'PREVENTIVE_CARE_DEXA_SCREENING_FOR_OSTEOPOROSIS_RECOMMENDED_FOR_PATIENTS_65_YEARS_AND_OVER',
  PreventiveCareInfluenzaVaccine = 'PREVENTIVE_CARE_INFLUENZA_VACCINE',
  PreventiveCarePapSmear = 'PREVENTIVE_CARE_PAP_SMEAR',
  PreventiveCarePneumovax23Vaccine = 'PREVENTIVE_CARE_PNEUMOVAX23_VACCINE',
  PreventiveCarePrevnar13Vaccine = 'PREVENTIVE_CARE_PREVNAR13_VACCINE',
  TransitionOfCare = 'MEDICATION_RECONCILIATION_POST_DISCHARGE_18_YEARS_AND_OVER',
  TRCEngage = 'TRC_ENGAGE',
  WellChildVisit = 'WELL_CHILD_VISIT',
}
